module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"enabled":"Ja","disabled":"Nein","zevLabel":"ZEV","zevInfoBoxTitle":"Zusammenschluss zum Eigenverbrauch (ZEV)","zevInfoBox":"Wenn der Zusammenschluss zum Eigenverbrauch ausgewählt ist, wird der PV-Strom auch für den Mieterstrom verwendet. Wenn nicht, wird PV-Strom lediglich für den Allgemeinstrom, Heizung und Warmwasser verwendet."}}')
  delete Component.options._Ctor
}
